module.exports = __webpack_public_path__ + "img/sankaku_87_blue.ba349567.png";